var exports = {
  "container": "MediaTimeDisplay.module__container___cm50Tl",
  "time": "MediaTimeDisplay.module__time___cm50Tl",
  "separator": "MediaTimeDisplay.module__separator___cm50Tl",
  "small": "MediaTimeDisplay.module__small___cm50Tl",
  "medium": "MediaTimeDisplay.module__medium___cm50Tl",
  "large": "MediaTimeDisplay.module__large___cm50Tl",
  "compact": "MediaTimeDisplay.module__compact___cm50Tl",
  "duration": "MediaTimeDisplay.module__duration___cm50Tl",
};

__webpack_require__.r(module.exports = exports);
